import type { Directive } from "vue";

export type TestDirective = Directive<HTMLElement, string>;

declare module "vue" {
	export interface ComponentCustomProperties {
		vTest: TestDirective;
	}
}

export const testDirective = {
	beforeMount(el, binding) {
		if (binding.value?.includes("_")) {
			throw new Error(`Please use dashes instead of underscores in the test directive value. Found: ${binding.value}`);
		} else {
			const testId = binding.value || "default-test-id";
			el.dataset.testId = testId;
		}
	}
} satisfies TestDirective;

export default testDirective;
